import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Platform,
} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {Network} from '../../../utils/network';
import {useDispatch} from 'react-redux';
import {
  avatar,
  email_white,
  kyc_process,
  loader_get,
  phone_white,
  verified_green,
} from '../../../utils/images';
import VerifyEmail from './VerifyEmail';
import moment from 'moment';
import BouncyCheckbox from 'react-native-bouncy-checkbox';
import {Button} from '../../../components/core/Button';
import CommonModal from '../../../commonComponents/commonModal';
import {setLoaderVisibility} from '../../../utils/commonredux/commonRedux.action';
import {Controller, useForm, useFormState} from 'react-hook-form';
import {Input} from '../../../components/core/Input';
import {
  isMobile,
  RegEx,
  requestGalleryPermission,
  requestPermision,
  trackMoengageEvent,
} from '../../../utils/commonMethods';
import {launchCamera, launchImageLibrary} from 'react-native-image-picker';
import {INDIA, REST_OF_WORLD} from '../../../utils/constants';
import FastImage from '../../../common/FastImage';
import {globalConfigurableData, globalConst, GlobalScreens} from '../../../utils/globalConstant';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import MobileEmailBottomSheet from './MobileEmailBottomSheet';
import {BasicDetailImport} from '../basicDetailsImport';
import {mobilesignInReact} from '../../Login/childComponents/googleSignIn';
import {AlertDialog} from '../../../components/core/AlertDialog';
import {pincodeDirectory} from 'india-pincode-lookup';
import Select from '../../../components/core/Select';
import {useToast} from '../../../components/core/Toast';

const RESTRICTED_STATES = [
  'Assam',
  'Odisha',
  'Andhra Pradesh',
  'Telangana',
  'Nagaland',
  'Sikkim',
  'Chhattisgarh'
];

const INDIAN_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal'
];

const BasicDetails = ({
  profileData,
  isImage,
  onBasicDetailSubmit,
  setProfileEmpty,
  onImageChange,
  image,
}) => {
  const userInfo = profileData;
  const region = userInfo?.region_code;
  const userName = userInfo ? userInfo.displayname : 'User';
  const mobileNo = userInfo ? userInfo.mobile : '';
  const pincode = userInfo ? userInfo.pincode : '';
  const dob = userInfo ? userInfo.dob : '';
  const dispatch = useDispatch();
  const email = userInfo?.email;
  const PAN = userInfo ? userInfo?.kycdetails?.number : '';
  const isProfileComplete = userInfo?.isProfileComplete;
  const [error, setError] = useState('');
  const [apiSuccess, setApiSuccess] = useState('');
  const [showEmail, setShowEmailVerify] = useState(false);
  const [startDate, setStartDate] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [isPhotoPicker, setIsPhotoPicker] = useState(false);
  const [mobileEmailSheet, setMobileEmailSheet] = useState(null);
  const [isCheckBoxSelected, setIsCheckboxSelected] = useState(true);
  const [open, setOpen] = useState(false);
  const [showStateConfirmation, setShowStateConfirmation] = useState(false);
  const [derivedState, setDerivedState] = useState('');
  const { toast } = useToast();
  const [isPincodeSubmitted, setIsPincodeSubmitted] = useState(false);
  const [tempDerivedState, setTempDerivedState] = useState('');

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: {errors, isValid, dirtyFields},
    control,
    setError: setErrorForm,
    clearErrors,
    setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      state: '',
      pinCode: '',
      Email: '',
      userName: '',
      mobileNo: '',
      dateOfBirth: '',
    }
  });

  const {isDirty} = useFormState({
    control,
  });

  const handleCheckbox = () => {
    setIsCheckboxSelected(!isCheckBoxSelected);
  };

  const onModify = async (data, e) => {
    if (isCheckBoxSelected) {
      e.preventDefault();
      if (isDirty || isImage || startDate || data?.pinCode) {
        // Validate pincode if it's being changed
        if (data?.pinCode && !derivedState) {
          setError('Please enter a valid pincode that allows us to determine your state');
          return;
        }

        const formData = {
          ...data,
          dateOfBirth: startDate,
          pinCode: data?.pinCode || watchPincode,
        };

        try {
          await onBasicDetailSubmit(formData);
          setError('');
        } catch (error) {
          console.error('Form submission error:', error);
          setError('Failed to update details');
        }
      } else {
        setError('Nothing to update');
      }
    }
  };

  const watchEmail = watch('Email');
  const watchPincode = watch('pinCode');

  const responseGoogleError = errorResponse => {
    setError(errorResponse?.error);
  };

  const profileSet = res => {
    setProfileEmpty({...userInfo, ...res?.user});
    setApiSuccess(res?.msg);
  };

  const responseGoogleSuccess = res => {
    mobilesignInReact(res, profileSet);
  };

  useEffect(() => {
    let timeout;
    if (error) {
      toast({
        title: 'Error',
        description: error,
        variant: 'destructive'
      });
      timeout = setTimeout(() => {
        setError('');
      }, 5000);
    }

    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [error]);

  useEffect(() => {
    if (isDirty || isImage) {
      setError('');
    }
  }, [isDirty, isImage]);

  useEffect(() => {
    let timeout;
    if (apiSuccess) {
      toast({
        title: 'Success',
        description: apiSuccess,
        variant: 'success'
      });
      timeout = setTimeout(() => {
        setApiSuccess('');
      }, 1500);
    }
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [apiSuccess]);

  useEffect(() => {
    if (region === INDIA) {
      blockedPinCode();
    }
  }, [watchPincode]);

  useEffect(() => {
    if (email) {
      setValue('Email', email);
    }
  }, [email]);

  useEffect(() => {
    let defaultValues = {};
    defaultValues.userName = userName;
    defaultValues.mobileNo = mobileNo;
    defaultValues.Email = email;
    defaultValues.pinCode = pincode;
    defaultValues.dateOfBirth = dob;
    reset({...defaultValues});

    // Set the startDate from dob if it exists
    if (dob) {
      setStartDate(dob);
    }

    // Only set initial state if pincode exists
    if (pincode && region === INDIA) {
      const state = getStateFromPincode(pincode);
      if (state) {
        setDerivedState(state);
        setValue('state', state);
      }
    }
  }, [userName, pincode, mobileNo, dob, region]);

  useEffect(() => {
    if (watchPincode && watchPincode.length === 6 && region === INDIA) {
      const state = getStateFromPincode(watchPincode);
      // Only handle validation if pincode is editable
      const isPincodeEditable = isEditable() && (!userInfo?.pincode || !userInfo?.state);
      
      if (state) {
        // Only show confirmation for new pincode entries
        if (watchPincode !== userInfo?.pincode) {
          setTempDerivedState(state);
          setShowStateConfirmation(true);
        } else {
          // For existing pincode, just set the state without confirmation
          setDerivedState(state);
          setValue('state', state);
        }
        clearErrors('pinCode');
      } else if (isPincodeEditable) {
        setTempDerivedState('');
        setDerivedState('');
        setValue('state', '');
        setErrorForm('pinCode', {
          type: 'manual',
          message: 'Please enter a valid pincode that allows us to determine your state'
        });
      }
    } else if (watchPincode && watchPincode.length < 6) {
      setTempDerivedState('');
      setDerivedState('');
      setValue('state', '');
      clearErrors('pinCode');
    }
  }, [watchPincode]);

  const onBottomSheetClose = () => {
    setShowEmailVerify(false);
  };

  const onVerifyClick = async e => {
    e.preventDefault();
    const reqobj = {
      email: watchEmail,
    };
    dispatch(setLoaderVisibility(true));
    trackMoengageEvent('Email OTP sent', {
      Email: watchEmail,
    });

    const res = await Network.sendOTPVerifyEmail(reqobj);

    if (res?.data?.success === 'true') {
      setShowEmailVerify(true);
    } else {
      if (typeof res?.data?.error === 'string') {
        setError(res.data?.error);
      } else {
        setError('Some error occurred');
      }
    }
    dispatch(setLoaderVisibility(false));
  };

  const getStateFromPincode = (pincode) => {
    try {
      if (!pincode || pincode.length !== 6) return null;
      
      const pincodeData = require('india-pincode-search');
      const result = pincodeData.search(pincode);
      
      if (result && Array.isArray(result) && result.length > 0) {
        return result[0].state;
      }
      return null;
    } catch (err) {
      console.error('Error looking up pincode:', err);
      return null;
    }
  };

  const blockedPinCode = async pincode => {
    if (!pincode || pincode.length !== 6) {
      setDerivedState('');
      return;
    }
    
    // Only check blocked pincode if the field is editable
    const isPincodeEditable = isEditable() && (!userInfo?.pincode || !userInfo?.state);
    if (!isPincodeEditable) return false;
    
    try {
      const state = getStateFromPincode(pincode);
      if (state) {
        setDerivedState(state);
      } else {
        setDerivedState('');
        setErrorForm('pinCode', {
          type: 'manual',
          message: 'Invalid pincode - unable to determine state',
        });
        return true;
      }

      const response = await Network.getBlockedPincode({pinCode: pincode});
      if (response?.data?.isBlocked) {
        setErrorForm('pinCode', {
          type: 'manual',
          message: 'Services not available for this pincode',
        });
        return true;
      }

      clearErrors('pinCode');
      return false;
    } catch (error) {
      console.error('Error checking pincode:', error);
      setDerivedState('');
      return false;
    }
  };

  const checkForBtnDisable = () => {
    if (
      Object.entries(errors).length ||
      isLoader > 0 ||
      !isCheckBoxSelected ||
      watchEmail !== email ||
      (watchPincode && watchPincode.length === 6 && !derivedState)
    ) {
      return true;
    }
    return false;
  };

  const isEditable = () => {
    return isProfileComplete ? false : true;
  };

  const onImageClick = async type => {
    setIsPhotoPicker(false);
    const isAndroid = Platform.OS === 'android';
    if (type === 'camera') {
      let requestPermision1;
      if (isAndroid) {
        requestPermision1 = await requestPermision('CAMERA');
      }

      if (!isAndroid || requestPermision1) {
        const options = {
          mediaType: 'photo',
          quality: 0.5,
          includeBase64: true,
        };
        const result = await launchCamera(options);

        onImageChange(result);
      }
    } else {
      let requestPermision1;
      if (isAndroid) {
        requestPermision1 = await requestGalleryPermission('CAMERA');
      }

      if (!isAndroid || requestPermision1) {
        const options = {
          mediaType: 'photo',
          quality: 0.5,
          includeBase64: true,
        };
        const result = await launchImageLibrary(options);

        onImageChange(result);
      }
    }
  };

  const handleDateChange = (date) => {
    const formattedDate = moment(date).format('DD-MM-YYYY');
    setValue('dateOfBirth', formattedDate);
    setStartDate(formattedDate);
    setOpen(false);
  };

  const handleVerifyClick = () => {
    setMobileEmailSheet(
      !profileData?.isEmailVerified ? 'email' : 'phone'
    );
  };

  return (
    <View style={styles.container}>
      {(!userInfo?.mobile || !profileData?.isEmailVerified) &&
        region === INDIA && (
          <TouchableOpacity
            style={styles.verifyButton}
            onPress={handleVerifyClick}>
            <View style={{position: 'absolute', left: 20}}>
              <FastImage
                source={
                  !profileData?.isEmailVerified
                    ? email_white()
                    : phone_white()
                }
                style={{height: 22, width: 22}}
              />
            </View>
            <Text style={styles.verifyButtonText}>
              {!profileData?.isEmailVerified
                ? 'Verify Email'
                : 'Verify Phone Number'}
            </Text>
          </TouchableOpacity>
        )}

      <View style={styles.inputContainer}>
        <Input
          name="userName"
          control={control}
          label={`Full Name${region !== INDIA ? '' : ' (As per Pan Card)'}`}
          variant="default"
          size="default"
          disabled={false}
          rules={{
            required: 'Please enter user name',
          }}
        />
      </View>

      {userInfo?.mobile && (
        <View style={styles.inputContainer}>
          <Input
            name="mobileNo"
            control={control}
            label="Mobile Number"
            variant="default"
            size="default"
            value={`${profileData?.isd_code} ${mobileNo}`}
            disabled={true}
            badge={profileData?.isEmailVerified && {
              text: "Verified",
              variant: "success",
              icon: verified_green()
            }}
          />
        </View>
      )}

      {GlobalScreens.Account.isKyc && region === INDIA && (
        <>
          <View style={styles.inputContainer}>
            <Input
              name="pinCode"
              control={control}
              label="Residential Address Pincode"
              variant="default"
              size="default"
              disabled={!isEditable() || (userInfo?.pincode && userInfo?.state)}
              numeric={true}
              rightIcon={isLoader ? loader_get() : null}
              rules={{
                required: !userInfo?.pincode && 'Please enter pin code',
                min: {
                  value: 100000,
                  message: !userInfo?.pincode && 'Please enter a valid 6-digit pincode'
                },
                max: {
                  value: 999999,
                  message: !userInfo?.pincode && 'Please enter a valid 6-digit pincode'
                },
                validate: (value) => {
                  const isPincodeEditable = isEditable() && (!userInfo?.pincode || !userInfo?.state);
                  if (isPincodeEditable && value && value.length === 6 && !derivedState) {
                    return 'Please enter a valid pincode that allows us to determine your state';
                  }
                  return true;
                }
              }}
              error={(!userInfo?.pincode || !userInfo?.state) ? errors?.pinCode?.message : undefined}
            />
            {userInfo?.pincode && userInfo?.state && (
              <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSmallText,
                  color: globalConfigurableData.secondaryTextColor1,
                  marginTop: 4,
                }}
                label="Pincode cannot be changed once submitted"
              />
            )}
          </View>

          <View style={styles.inputContainer}>
            <Input
              name="state"
              control={control}
              label="State"
              variant="default"
              size="default"
              disabled={true}
              value={derivedState || userInfo?.state || ''}
              placeholder="State will be derived from pincode"
            />
          </View>
        </>
      )}

      <View style={styles.inputContainer}>
        {Platform.OS === 'web' ? (
          <Controller
            control={control}
            name="dateOfBirth"
            rules={{ required: 'Please enter your DOB' }}
            render={({ field: { onChange, value } }) => {
              const [isOpen, setIsOpen] = useState(false);
              
              return (
                <div onClick={() => !isProfileComplete && setIsOpen(true)} style={{ cursor: isProfileComplete ? 'not-allowed' : 'pointer', position: 'relative' }}>
                  <Input
                    name="dateOfBirth"
                    control={control}
                    label="Date of Birth (DD-MM-YYYY)"
                    variant="default"
                    size="default"
                    value={startDate || ''}
                    disabled={isProfileComplete}
                    placeholder="DD-MM-YYYY"
                    rules={{
                      required: 'Please enter your DOB'
                    }}
                    isDateInput={true}
                  />
                  <div style={{ position: 'absolute', zIndex: 999 }}>
                    <BasicDetailImport.DatePicker
                      selected={startDate ? moment(startDate, 'DD-MM-YYYY').toDate() : null}
                      onChange={(date) => {
                        handleDateChange(date);
                        onChange(moment(date).format('DD-MM-YYYY'));
                        setIsOpen(false);
                      }}
                      maxDate={new Date(moment().subtract(18, 'years'))}
                      minDate={new Date(1950, 0, 1)}
                      dateFormat="dd-MM-yyyy"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      open={isOpen}
                      onClickOutside={() => setIsOpen(false)}
                      customInput={<div style={{ display: 'none' }} />}
                    />
                  </div>
                </div>
              );
            }}
          />
        ) : (
          <>
            <TouchableOpacity
              onPress={() => {
                if (!isProfileComplete || !startDate) {
                  setOpen(true);
                }
              }}>
              <Input
                name="dateOfBirth"
                control={control}
                label="Date of Birth (DD-MM-YYYY)"
                variant="default"
                size="default"
                value={startDate || ''}
                disabled={true}
                placeholder="DD-MM-YYYY"
                rules={{
                  required: 'Please enter your DOB'
                }}
                isDateInput={true}
              />
            </TouchableOpacity>

            <CommonModal
              onModalCallBack={() => setOpen(false)}
              showModal={open}
              customModalStyle={styles.datePickerModal}>
              <View style={styles.datePickerContainer}>
                <BasicDetailImport.DatePicker
                  value={startDate ? moment(startDate, 'DD-MM-YYYY').toDate() : new Date(moment().subtract(18, 'years'))}
                  onChange={handleDateChange}
                  maximumDate={new Date(moment().subtract(18, 'years'))}
                  minimumDate={new Date(1950, 0, 1)}
                  mode="date"
                  display="spinner"
                />
                <TouchableOpacity
                  style={styles.doneBtnContainer}
                  onPress={() => setOpen(false)}>
                  <Text style={styles.doneBtn}>Done</Text>
                </TouchableOpacity>
              </View>
            </CommonModal>
          </>
        )}
      </View>

      {profileData?.isEmailVerified && (
        <View style={styles.inputContainer}>
          <Input
            name="Email"
            control={control}
            label="Email"
            variant="default"
            size="default"
            disabled={!isEditable()}
            rules={{
              required: 'Please enter email',
              pattern: {
                value: RegEx.email,
                message: 'Please enter a valid email',
              },
            }}
            badge={
              profileData?.isEmailVerified && email === profileData?.email
                ? {
                    text: "Verified",
                    variant: "success",
                    icon: verified_green()
                  }
                : {
                    text: "Verify",
                    variant: "primary",
                    onPress: onVerifyClick
                  }
            }
          />
        </View>
      )}

      <View style={styles.footerContainer}>
        <View style={styles.checkboxContainer}>
          <BouncyCheckbox
            isChecked={isCheckBoxSelected}
            size={20}
            disableText={true}
            fillColor={globalConfigurableData.primaryTextColor1}
            unfillColor={Colors.bgWhite}
            iconStyle={{borderColor: globalConfigurableData.borderColor, borderRadius: 4}}
            innerIconStyle={{borderWidth: 1, borderRadius: 4}}
            onPress={() => handleCheckbox()}
          />
          <FormTextLabel
            labelStyles={styles.checkboxText}
            label={
              'I declare that all the information shared above is correct to the best of my knowledge & I\'m legally competent to trade on .'
            }
            rest={{appName: globalConfigurableData?.appName}}
          />
        </View>

        <Button
          variant={checkForBtnDisable() ? 'disabled' : 'primary'}
          onPress={handleSubmit(onModify)}
          translate={true}
          style={styles.submitButton}
        >
          Submit
        </Button>
      </View>

      {Platform.OS !== 'web' && commonComp(true)}
      <CommonModal
        onModalCallBack={onBottomSheetClose}
        customModalStyle={styles.modalStyle}
        showModal={showEmail}>
        <VerifyEmail
          email={watchEmail}
          onClose={() => {
            setTimeout(() => {
              onBottomSheetClose();
            }, globalConst?.buttonTimer);
          }}
        />
      </CommonModal>

      <CommonModal
        onModalCallBack={() => setMobileEmailSheet(null)}
        showModal={mobileEmailSheet ? true : false}
        customModalStyle={styles.modalStyle}>
        <MobileEmailBottomSheet
          setMobileEmailSheet={setMobileEmailSheet}
          mobileEmailSheet={mobileEmailSheet}
          responseGoogleSuccess={responseGoogleSuccess}
          responseGoogleError={responseGoogleError}
          showMobileOnly={!profileData?.isEmailVerified ? false : true}
          isProfile={true}
        />
      </CommonModal>

      <AlertDialog
        isOpen={showStateConfirmation}
        onClose={() => {
          setShowStateConfirmation(false);
          setTempDerivedState('');
          clearErrors('pinCode');
        }}
        title="Confirm Your State"
        description="Based on your pincode, we've identified your state as:"
        emphasizedText={tempDerivedState}
        cancelText="Change Pincode"
        actionText="Confirm"
        onAction={() => {
          // Set both derived state and form state from the temporary state
          setDerivedState(tempDerivedState);
          setValue('state', tempDerivedState);
          setShowStateConfirmation(false);
          clearErrors('pinCode');
          
          toast({
            title: 'State Confirmed',
            description: `Your state has been set to ${tempDerivedState}`,
            variant: 'success',
          });
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 16,
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.red,
    marginTop: 4,
  },
  successText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.green,
    marginTop: 4,
  },
  verifyButton: {
    backgroundColor: Colors.black,
    borderRadius: 8,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
  },
  verifyButtonText: {
    ...globalFontStyle.appFontRegular,
    color: Colors.bgWhite,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    paddingRight: 16,
  },
  checkboxText: {
    color: globalConfigurableData.secondaryTextColor1,
    ...globalFontStyle.appFontBody,
    fontSize: 12,
    lineHeight: 18,
    opacity: 0.8,
    flex: 1,
    marginLeft: 12,
  },
  footerContainer: {
    marginTop: 24,
  },
  submitButton: {
    marginTop: 16,
  },
  modalStyle: {
    ...globalStyle.modalView,
    alignItems: 'stretch',
  },
  datePickerContainer: {
    backgroundColor: Colors.bgWhite,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderTopWidth: 1,
    borderTopColor: Colors.grey3,
  },
  doneBtnContainer: {
    alignItems: 'flex-end',
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: Colors.grey3,
  },
  doneBtn: {
    color: Colors.blue,
    fontSize: 16,
    fontWeight: '600',
  },
  datePickerModal: {
    ...globalStyle.modalView,
    alignItems: 'stretch',
  },
  datePickerWrapper: {
    width: '100%',
  },
});

export default BasicDetails;
